import React, {
    useState
} from "react";

import {
    Modal,
    Form,
    Input,
    DatePicker,
    Button,
    Typography,
    Space,
    message
} from "antd";

import {
    PlusOutlined,
    CalendarOutlined
} from "@ant-design/icons";

import dayjs from "dayjs";

import api from "../../api/api";

import {
    useAcademicYear
} from "../../AcademicYearContext";


const {
    Title,
    Text
} = Typography;



const COLORS = {

    black:"#111111",

    orange:"#f97316",

    camel:"#c19a6b",

    white:"#ffffff"

};



const PostTodoList = ({
    open,
    setOpen
}) => {


const {
    selectedYear
} = useAcademicYear();



const [
    loading,
    setLoading
] = useState(false);



const [
    form
] = Form.useForm();





const submitTodo = async(values)=>{


    if(!selectedYear){

        message.error(
            "Please select academic year first."
        );

        return;

    }



    try{


        setLoading(true);



        await api.post(

            "/todos/",

            {

                title:
                values.title,


                description:
                values.description || "",


                reminder_date:
                values.reminder_date.format(
                    "YYYY-MM-DD"
                ),


                academic_year:
                selectedYear.id

            }

        );



        message.success(
            "Todo created successfully"
        );



        form.resetFields();



    }
    catch(error){


        console.log(error);


        message.error(
            "Failed to create todo"
        );


    }
    finally{


        setLoading(false);


    }


};





return (

<Modal


    open={open}


    centered


    width={650}


    footer={null}


    onCancel={()=>{}}


    closable={false}


    destroyOnClose



    styles={{

        content:{

            borderRadius:25,

            padding:0,

            overflow:"hidden"

        }

    }}



>


<CardHeader />



<Form

layout="vertical"

form={form}

onFinish={submitTodo}

style={{
    padding:30
}}

>



<Form.Item

label="Task Title"

name="title"

rules={[
{
required:true,
message:"Enter task title"
}
]}

>


<Input

size="large"

placeholder="Example: Call parent meeting"

/>


</Form.Item>





<Form.Item

label="Description"

name="description"

>


<Input.TextArea

rows={4}

placeholder="Describe your task"

/>


</Form.Item>






<Form.Item

label="Reminder Date"

name="reminder_date"

rules={[
{
required:true,
message:"Select reminder date"
}
]}

>


<DatePicker

size="large"

style={{
width:"100%"
}}

suffixIcon={
<CalendarOutlined/>
}


disabledDate={
current =>
current &&
current <
dayjs()
.startOf("day")
}


/>


</Form.Item>





<Space

style={{
width:"100%",
justifyContent:"flex-end"
}}

>


<Button

size="large"

onClick={()=>setOpen(false)}

>

Cancel

</Button>





<Button

htmlType="submit"

loading={loading}

size="large"

icon={
<PlusOutlined/>
}


style={{

background:
COLORS.orange,

color:
COLORS.white,

border:"none",

fontWeight:700

}}

>


Save Todo


</Button>


</Space>



</Form>



</Modal>


);

};





const CardHeader=()=>{


return (

<div

style={{

background:
`linear-gradient(
135deg,
${COLORS.black},
${COLORS.camel}
)`,

padding:25,

color:"white"

}}

>


<Space>


<PlusOutlined

style={{

fontSize:30,

color:
COLORS.orange

}}

/>



<div>


<Title

level={3}

style={{

color:"white",

margin:0

}}

>

Create Todo Task

</Title>



<Text

style={{

color:"#eee"

}}

>

Plan your next activity

</Text>



</div>


</Space>


</div>


);


};



export default PostTodoList;